// extracted by mini-css-extract-plugin
export default {"chevronCommon":"ProductHeading_common_chevronCommon__75ejp","rowTwo":"ProductHeading_common_rowTwo__gLbi5"};